import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router";
import { OctagonAlert } from "lucide-react";

interface TrackModalProps {
	isOpen: boolean;
	close: () => void;
}

export function ExpiredListeningUpgradeModal({
	isOpen,
	close,
}: TrackModalProps) {
	const navigate = useNavigate();

	const handleClick = () => {
		close();
		navigate("/pricing");
	};

	return (
		<Dialog open={isOpen} onOpenChange={close}>
			<DialogContent className="sm:max-w-md max-h-[90vh] overflow-y-auto p-0">
				<div className="flex flex-col">
					<div className="p-6">
						<DialogHeader className="mb-4">
							<div className="flex items-center justify-center gap-2 mb-2">
								<OctagonAlert className="size-6 text-primary" />
								<DialogTitle className="text-2xl">
									Daily Listening Time Expired
								</DialogTitle>
							</div>
							<DialogDescription>
								To access all-day, unlimited listening of all our soundtracks,
								please upgrade to Coffitivity Premium.
							</DialogDescription>
							<DialogDescription className="text-primary">
								All premium subscriptions include a{" "}
								<span className="font-medium">7-day free trial</span>, so you
								can <span className="font-medium">try before you buy</span>!
							</DialogDescription>
						</DialogHeader>

						<div className="flex flex-col gap-3 mt-6">
							<Button className="w-full" onClick={handleClick}>
								Upgrade Now
							</Button>
							<Button
								variant="outline"
								className="w-full"
								onClick={() => {
									close();
									navigate("/rewards");
								}}
							>
								Get More Time
							</Button>
							<Button variant="ghost" className="w-full" onClick={close}>
								Maybe Later
							</Button>
						</div>
					</div>
				</div>
			</DialogContent>
		</Dialog>
	);
}
